/* SPF redesign — article page behaviour: table of contents, "Källor" list, table scroll wrappers,
   protein calculator. Vanilla, no dependencies. */
(() => {
  const SOURCES_HEADING = /^källor:?$/i;
  const scrollWraps = [];

  const slugify = (text) =>
    text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'avsnitt';

  const assignIds = (headings) => {
    const used = new Set(headings.map((h) => h.id).filter(Boolean));
    headings.forEach((heading) => {
      if (heading.id) return;
      const base = slugify(heading.textContent);
      let id = base;
      let n = 2;
      while (used.has(id) || document.getElementById(id)) {
        id = `${base}-${n}`;
        n += 1;
      }
      used.add(id);
      heading.id = id;
    });
  };

  const buildToc = (article, body) => {
    const toc = article.querySelector('[data-spf-toc]');
    const nav = toc && toc.querySelector('[data-spf-toc-nav]');
    if (!nav) return;
    const headings = [...body.querySelectorAll('h2')].filter((h) => h.textContent.trim());
    if (headings.length < 2) return;
    assignIds(headings);
    nav.replaceChildren(
      ...headings.map((heading) => {
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        return link;
      })
    );
    toc.hidden = false;
  };

  const markSources = (body) => {
    body.querySelectorAll('h2').forEach((heading) => {
      if (!SOURCES_HEADING.test(heading.textContent.trim())) return;
      heading.classList.add('spf-article__sources-heading');
      for (let el = heading.nextElementSibling; el && !/^H[1-6]$/.test(el.tagName); el = el.nextElementSibling) {
        if (el.tagName === 'OL' || el.tagName === 'UL') {
          el.classList.add('spf-article__sources');
          return;
        }
      }
    });
  };

  const syncScrollable = (wrap) => {
    if (wrap.scrollWidth > wrap.clientWidth) {
      wrap.tabIndex = 0;
      wrap.setAttribute('role', 'region');
      wrap.setAttribute('aria-label', 'Tabell');
    } else {
      wrap.removeAttribute('tabindex');
      wrap.removeAttribute('role');
      wrap.removeAttribute('aria-label');
    }
  };

  const wrapTables = (body) => {
    body.querySelectorAll('table').forEach((table) => {
      if (table.parentElement.classList.contains('spf-article__table-scroll')) return;
      const wrap = document.createElement('div');
      wrap.className = 'spf-article__table-scroll';
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
      scrollWraps.push(wrap);
      syncScrollable(wrap);
    });
  };

  const initCalculator = (calc) => {
    const range = calc.querySelector('[data-spf-calc-range]');
    const weightOut = calc.querySelector('[data-spf-calc-weight]');
    const gramsOut = calc.querySelector('[data-spf-calc-grams]');
    const mealOut = calc.querySelector('[data-spf-calc-meal]');
    const goals = [...calc.querySelectorAll('[data-spf-calc-goal]')];
    if (!range || !weightOut || !gramsOut || !mealOut || !goals.length) return;

    const update = () => {
      const active = goals.find((goal) => goal.getAttribute('aria-pressed') === 'true') || goals[0];
      const weight = Number(range.value);
      const grams = Math.round(weight * Number(active.dataset.factor));
      weightOut.textContent = `${weight} kg`;
      gramsOut.textContent = `${grams} g`;
      mealOut.textContent = String(Math.round(grams / 4));
    };

    range.addEventListener('input', update);
    goals.forEach((goal) => {
      goal.addEventListener('click', () => {
        goals.forEach((other) => other.setAttribute('aria-pressed', String(other === goal)));
        update();
      });
    });
  };

  const init = () => {
    document.querySelectorAll('.spf-article').forEach((article) => {
      const body = article.querySelector('[data-spf-body]');
      if (!body || body.dataset.spfReady) return;
      body.dataset.spfReady = 'true';
      wrapTables(body);
      markSources(body);
      buildToc(article, body);
    });
    document.querySelectorAll('[data-spf-calc]').forEach((calc) => {
      if (calc.dataset.spfReady) return;
      calc.dataset.spfReady = 'true';
      initCalculator(calc);
    });
  };

  window.addEventListener('resize', () => {
    scrollWraps.forEach((wrap) => {
      if (wrap.isConnected) syncScrollable(wrap);
    });
  });
  document.addEventListener('shopify:section:load', init);
  init();
})();
